import type { SetupStatus } from '@deizi/shared';
import { Link } from 'react-router';
import { Icon } from '../../components/Icon';
import { Alert } from '../../components/States';
import { SETUP_ITEM_LABELS, STEP_FOR_ITEM } from '../../lib/setup-api';
import { StepHead, WizardFooter } from './WizardParts';

/** Step 6 · Pronto para o primeiro orçamento. */
export function StepDone({
  status,
  onBack,
  onGo,
}: {
  status: SetupStatus;
  onBack: () => void;
  onGo: (step: number) => void;
}) {
  return (
    <>
      <StepHead title={status.readyToQuote ? 'Pronto para o primeiro orçamento' : 'Quase lá'}>
        {status.readyToQuote
          ? 'Isso é o que ficou configurado. Tudo pode ser mudado depois.'
          : 'Ainda falta um item para calcular preços.'}
      </StepHead>
      {status.business === 'skipped' ? (
        <Alert tone="warn">
          <b>Dados do negócio ficaram para depois.</b> Um aviso no início lembra você. Sem eles, o
          PDF do orçamento sai sem logo e sem CNPJ.{' '}
          <button
            type="button"
            className="btn sm g"
            style={{ padding: 0, minHeight: 0 }}
            onClick={() => onGo(1)}
          >
            Completar agora
          </button>
        </Alert>
      ) : null}
      <section className="card" style={{ padding: '4px 18px' }}>
        {status.items.map((i) => (
          <div key={i.key} className="listrow">
            <span className={i.done ? 'box on' : 'box'} style={{ borderRadius: '50%' }}>
              {i.done ? <Icon name="check" size={14} strokeWidth={3} /> : null}
            </span>
            <div className="grow" style={{ minWidth: 0 }}>
              <p style={{ fontWeight: 500 }}>{SETUP_ITEM_LABELS[i.key].title}</p>
              <p className="xs muted">{i.detail ?? SETUP_ITEM_LABELS[i.key].todo}</p>
            </div>
            <button type="button" className="btn sm" onClick={() => onGo(STEP_FOR_ITEM[i.key])}>
              Editar
            </button>
          </div>
        ))}
      </section>
      {status.readyToQuote ? (
        <section className="card row wrap" style={{ gap: 16, border: '2px solid var(--co)' }}>
          <span className="ph" style={{ width: 96, height: 72, flex: '0 0 96px' }}>
            placa
          </span>
          <div className="grow col" style={{ gap: 6, minWidth: 220 }}>
            <h2>Teste com um arquivo de exemplo</h2>
            <p className="sm muted">
              suporte-celular-x2d.gcode.3mf · 0h24 · 12,8 g · 1 unidade. Veja o custo e o preço por
              canal em segundos.
            </p>
            <div className="row wrap" style={{ gap: 10 }}>
              <Link className="btn p" to="/orcamento-rapido?exemplo=1">
                Abrir orçamento rápido com arquivo de exemplo
              </Link>
              <Link className="btn" to="/">
                Ir para o início
              </Link>
            </div>
          </div>
        </section>
      ) : (
        <div className="row wrap" style={{ gap: 10 }}>
          <Link className="btn p" to="/orcamento-rapido">
            Abrir orçamento rápido
          </Link>
          <Link className="btn" to="/">
            Ir para o início
          </Link>
        </div>
      )}
      <WizardFooter onBack={onBack} />
    </>
  );
}
